import React from 'react'
import { Redirect } from 'react-router-dom'
import {
  Segment,
  Table,
  Grid,
  Header,
  Icon,
  Button,
  Input,
  Dropdown,
  Message,
  Label,
  Menu,
  Popup,
  Loader
} from 'semantic-ui-react'
import { NavLink } from 'react-router-dom'

import find from 'lodash/find'

import { canEditMarks } from '../../utils/workflowStatus'
import groupBy from 'lodash/groupBy'
import orderBy from 'lodash/orderBy'
import constantCase from 'constant-case'

import './Grades.css'
import GradesReadCSV from './GradesReadCSV'
import GradesApproval from './GradesApproval'

const _ = { find, groupBy, orderBy}

const changeCase = {
  constantCase: constantCase
}

const GradesPV = (props) => {
  if (props.auth) {
    const {
      column, direction, section, quarter, error, success, fileName, dirtyInput,
      sectionStudents, sectionSubject, username, areGradesSaved, userType, userId,
      scheme
    } = props;

    if(section.length !== 1) return <Loader active inline='centered' />;
    if(sectionSubject.length !== 1) return <Loader active inline='centered' />;
    if(!scheme) return <Loader active inline='centered' />;

    // Grade 1 records letters (A-E); everyone else records numbers.
    const isDescriptive = scheme.mode === 'descriptive-pace';
    const minGrade = scheme.minGrade;
    const maxGrade = scheme.maxGrade;

    const sectionSubjectDetail = _.find(sectionSubject[0].details, {
      quarter: parseInt(quarter),
      type: 'grade'
    });

    // Shared with the PACE grid, so entry on both freezes at the same point on
    // the ladder. See src/utils/workflowStatus.js.
    const isDisabled = !canEditMarks(sectionSubjectDetail.status, {
      userType,
      isSubjectTeacher: sectionSubject[0].teacherId === userId,
    });

    const gender = _.groupBy(sectionStudents, o => o.student.gender)
    let currentDataMale = [], currentDataFemale = [];
    if(gender.hasOwnProperty('Male')) {
      currentDataMale = gender['Male'];
    }

    if(gender.hasOwnProperty('Female')) {
      currentDataFemale = gender['Female'];
    }

    const studentsTableMale = currentDataMale.map((sectionStudent, key )=> {
      const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
      if (props[changeCase.constantCase(studentName)] === undefined){
        return null;
      }  else {
        return (
          <Table.Row key={key} className='sections-table-row'>
            <Table.Cell>{studentName}</Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[changeCase.constantCase(studentName)] === 0? 'On Hold' : props[changeCase.constantCase(studentName)]} </span> :
                  isDescriptive ?
                  <Dropdown
                    name={changeCase.constantCase(studentName)}
                    selection
                    clearable
                    className='grades-input'
                    placeholder='Rating'
                    options={scheme.scaleOptions}
                    value={props[changeCase.constantCase(studentName)] || ''}
                    onChange={props.handleChange}
                  /> :
                  <Input
                    name={changeCase.constantCase(studentName)}
                    size='small'
                    className='grades-input'
                    value={props[changeCase.constantCase(studentName)]}
                    onChange={props.handleChange}
                  />
              }
            </Table.Cell>
          </Table.Row>
        );
      }
    });

    const studentsTableFemale = currentDataFemale.map((sectionStudent, key )=> {
      const studentName = sectionStudent.student.lastName +', '+ sectionStudent.student.firstName;
      if (props[changeCase.constantCase(studentName)] === undefined){
        return null;
      } else {
        return (
          <Table.Row key={key} className='sections-table-row'>
            <Table.Cell>{studentName}</Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[changeCase.constantCase(studentName)] === 0? 'On Hold' : props[changeCase.constantCase(studentName)]} </span> :
                  isDescriptive ?
                  <Dropdown
                    name={changeCase.constantCase(studentName)}
                    selection
                    clearable
                    className='grades-input'
                    placeholder='Rating'
                    options={scheme.scaleOptions}
                    value={props[changeCase.constantCase(studentName)] || ''}
                    onChange={props.handleChange}
                  /> :
                  <Input
                    name={changeCase.constantCase(studentName)}
                    size='small'
                    className='grades-input'
                    value={props[changeCase.constantCase(studentName)]}
                    onChange={props.handleChange}
                  />
              }
            </Table.Cell>
          </Table.Row>
        );
      }
    });

    const headers = (
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell
            textAlign='center'
            sorted={column === 'name' ? direction : null}
            onClick={() => props.handleSort('name')}
          >
            Name
          </Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Grade</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
    )

    const activePeriod = scheme
      ? scheme.periods.find((p) => p.index === parseInt(quarter, 10))
      : null;
    const quarterLabel = activePeriod ? activePeriod.label : 'No Quarter';
    const sortedCreated = _.orderBy(props.created, ['createdDate'], ['asc']);
    const createdTableBody = sortedCreated.map((create, key )=> {
      const subject = _.find(props.subjects, {
        subjectId: create.sectionSubject.subjectId
      });

      return (
        <Table.Row key={key}>
          <Table.Cell>
            <NavLink  to={`/grades/${create.sectionSubject.sectionId}/${create.sectionSubject.sectionSubjectId}?quarter=${quarter}`}>
              {subject.name}
            </NavLink>
          </Table.Cell>
        </Table.Row>
      );
    });
    const sortedChecked = _.orderBy(props.checked, ['checkedDate'], ['asc']);
    const checkedTableBody = sortedChecked.map((check, key )=> {
      const subject = _.find(props.subjects, {
        subjectId: check.sectionSubject.subjectId
      });

      return (
        <Table.Row key={key}>
          <Table.Cell>
            <NavLink  to={`/grades/${check.sectionSubject.sectionId}/${check.sectionSubject.sectionSubjectId}?quarter=${quarter}`}>
              {subject.name}
            </NavLink>
          </Table.Cell>
        </Table.Row>
      );
    });
    const sortedReviewed = _.orderBy(props.reviewed, ['createdDate'], ['asc']);
    const reviewedTableBody = sortedReviewed.map((review, key )=> {
      const subject = _.find(props.subjects, {
        subjectId: review.sectionSubject.subjectId
      });

      return (
        <Table.Row key={key}>
          <Table.Cell>
            <NavLink  to={`/grades/${review.sectionSubject.sectionId}/${review.sectionSubject.sectionSubjectId}?quarter=${quarter}`}>
              {subject.name}
            </NavLink>
          </Table.Cell>
        </Table.Row>
      );
    });

    return (
      <div>
        <Segment>
          {
            sectionStudents.length === 0 ?
            <Segment placeholder>
              <Header icon>
                <Icon name='database' />
                Populate the {section[0].gradeLevel} - {section[0].name} with students.
              </Header>
              <Button primary>Section Page</Button>
            </Segment> :
            <Grid>
              <Grid.Row className="grades-title-row" columns={3}>
                <Grid.Column width={6}>
                  <span className="grades-title">
                    {sectionSubject[0].subject.name}
                  </span>
                  <br/>
                  <span className="grades-subtitle">
                    {section[0].gradeLevel} - {section[0].name}
                  </span>
                </Grid.Column>
                <Grid.Column width={4}>
                </Grid.Column>
                <Grid.Column width={6} textAlign='right'>
                  <span className="grades-title">
                    {quarterLabel}
                  </span>
                  <br/>
                  {
                    sectionSubjectDetail.status === 'Approved' ?
                    <Label color='green' horizontal>
                      {sectionSubjectDetail.status}
                    </Label> :
                    <Label color='yellow' horizontal>
                      {sectionSubjectDetail.status === 'Resubmit' ? 'For Resubmission' : sectionSubjectDetail.status}
                    </Label>
                  }
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={16}>
                <Menu compact>
                    {
                      userType === 'admin' ||  userType === 'levelHead'?
                      <Popup
                        on='click'
                        position='bottom center'
                        trigger={
                          <Menu.Item as='a'>
                            <Icon name='check' /> For Checking
                            <Label color={props.created.length === 0 ? 'green' : 'red'} floating>
                              {props.created.length}
                            </Label>
                          </Menu.Item>
                        }
                        className={props.created.length === 0 ? '' : 'popup-reminders'}
                      >
                      <Table basic='very' size='small'>
                        <Table.Body>
                          {createdTableBody}
                        </Table.Body>
                      </Table>
                      </Popup>: null
                    }
                    {
                      userType === 'admin' ||  userType === 'registrar'?
                      <Popup
                        on='click'
                        position='bottom center'
                        trigger={
                          <Menu.Item as='a'>
                            <Icon name='book' /> For Review
                            <Label color={props.checked.length === 0 ? 'green' : 'red'} floating>
                              {props.checked.length}
                            </Label>
                          </Menu.Item>
                        }
                        className={props.checked.length === 0 ? '' : 'popup-reminders'}
                      >
                      <Table basic='very' size='small'>
                        <Table.Body>
                          {checkedTableBody}
                        </Table.Body>
                      </Table>
                      </Popup>: null
                    }
                    {
                      userType === 'admin' ||  userType === 'principal'?
                      <Popup
                        on='click'
                        position='bottom center'
                        trigger={
                          <Menu.Item as='a'>
                            <Icon name='thumbs up' /> For Approval
                            <Label color={props.reviewed.length === 0 ? 'green' : 'red'} floating>
                              {props.reviewed.length}
                            </Label>
                          </Menu.Item>
                        }
                        className={props.reviewed.length === 0 ? '' : 'popup-reminders'}
                      >
                      <Table basic='very' size='small'>
                        <Table.Body>
                          {reviewedTableBody}
                        </Table.Body>
                      </Table>
                      </Popup>: null
                    }
                  </Menu>
                  {
                    areGradesSaved &&
                    <GradesApproval
                      username={username}
                      userType={userType}
                      fileName={fileName}
                      sectionCode={sectionSubject[0].subject.code}
                      sectionSubjectDetail={sectionSubjectDetail}
                      onCheckPaceProgress={props.onCheckPaceProgress}
                      paceUrl={scheme.usesPace
                        ? `/pace/${sectionSubject[0].sectionId}/${sectionSubject[0].sectionSubjectId}?quarter=${quarter}`
                        : null}
                      open={props.open}
                      handleApprovalOpen={props.handleApprovalOpen}
                      handleApprovalClose={props.handleApprovalClose}
                      handleUploadFileChange={props.handleUploadFileChange}
                      handleUpdateSectionSubjectDetails={props.handleUpdateSectionSubjectDetails}
                    />
                  }
                  <Button.Group floated='right'>
                    <Button
                      color='green'
                      onClick={props.handleSubmit}
                      icon labelPosition='left'
                    ><Icon name='save' />
                      Save Grades
                    </Button>
                    <Button.Or />
                    <GradesReadCSV
                      handleFileChange={props.handleFileChange}
                      handleDataSave={props.handleDataSave}
                    />
                  </Button.Group>
                </Grid.Column>
              </Grid.Row>
              {
                error ?
                <Grid.Row>
                  <Grid.Column width={16}>
                    <Message
                      error
                      header={isDescriptive ? 'Rating Error' : 'Grade Error'}
                      content={typeof error === 'string'
                        ? error
                        : 'Grades must be between ' + minGrade + ' and ' + maxGrade +
                          '. You can input 0 for grades that are on hold or incomplete.'}
                    />
                  </Grid.Column>
                </Grid.Row> :
                null
              }
              {
                dirtyInput ?
                <Grid.Row>
                  <Grid.Column width={16}>
                    <Message
                      warning
                      header='Some changes were made.'
                      content="Please save."
                    />
                  </Grid.Column>
                </Grid.Row> :
                null
              }
              {
                success ?
                <Grid.Row>
                  <Grid.Column width={16}>
                    <Message
                      positive
                      header='Grades successfully saved!'
                      content='Upload supporting files and add notes to proceed.'
                    />
                  </Grid.Column>
                </Grid.Row> :
                null
              }
              {
                sectionSubjectDetail.status === 'Discarded' ?
                <Grid.Row>
                  <Grid.Column width={16}>
                    <Message
                      warning
                      header={`Your submission was discarded by ${sectionSubjectDetail.discardBy}`}
                      content={sectionSubjectDetail.discardNotes}
                    />
                  </Grid.Column>
                </Grid.Row> :
                null
              }
              <Grid.Row>
                <Grid.Column width={8}>
                  <h4>Male</h4>
                  <Table celled selectable sortable striped compact size='small'>
                    {headers}

                    <Table.Body>{studentsTableMale}</Table.Body>

                  </Table>
                </Grid.Column>
                <Grid.Column width={8}>
                  <h4>Female</h4>
                  <Table celled selectable sortable striped compact size='small'>
                    {headers}

                    <Table.Body>{studentsTableFemale}</Table.Body>

                  </Table>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          }

        </Segment>
      </div>
    )
  } else {
    return <Redirect to='/' />
  }

}

export default GradesPV;
